/**
 * `AW12` — el borde de métricas, disponible para el árbol.
 *
 * Mismo patrón que `contexto-borde-exportacion.tsx` y por la misma razón de
 * fondo: la pantalla de métricas lo necesita y está a varios niveles de la raíz,
 * así que la alternativa es plomería por props a través del montaje.
 *
 * Inyectado, el borde se puede reemplazar por un doble: la pantalla se puede
 * ejercer contra un doble en memoria, sin base, sin red y sin el módulo real.
 */

import { createContext, useContext } from "react"
import type { BordeMetricas } from "./metricas/borde-metricas.ts"

/**
 * Sin valor por defecto, igual que los otros contextos de borde. Un doble por
 * defecto haría que un componente montado fuera del proveedor anduviera igual,
 * escribiendo en el aire. Falla en el primer render.
 */
const ContextoBordeMetricas = createContext<BordeMetricas | null>(null)

export const ProveedorBordeMetricas = ContextoBordeMetricas.Provider

export function useBordeMetricas(): BordeMetricas {
  const borde = useContext(ContextoBordeMetricas)
  if (borde === null) {
    throw new Error(
      "useBordeMetricas() se llamó fuera de <ProveedorBordeMetricas>. El borde se arma en App.tsx con la configuración ya leída.",
    )
  }
  return borde
}
